/**
 * Links to national tire retailers' own store finders. Names only, no logos:
 * Tread AI isn't affiliated with any of them.
 */
const SHOPS = [
  { name: 'America’s Tire', note: 'California’s name for Discount Tire. Free flat repairs and tire checks.', url: 'https://www.americastire.com/store-locator', where: 'California' },
  { name: 'Discount Tire', note: 'The largest independent tire retailer in the US.', url: 'https://www.discounttire.com/store-locator', where: 'Nationwide' },
  { name: 'Big O Tires', note: 'Tires plus brakes, alignment and oil changes.', url: 'https://www.bigotires.com/store-locator', where: 'Nationwide' },
  { name: 'Les Schwab', note: 'Known for free pre-trip safety checks.', url: 'https://www.lesschwab.com/stores/', where: 'West and Mountain states' },
  { name: 'Firestone Complete Auto Care', note: 'Tires, alignment and full auto service.', url: 'https://www.firestonecompleteautocare.com/local/', where: 'Nationwide' },
  { name: 'Tire Rack', note: 'Order online and have them fitted at a nearby installer.', url: 'https://www.tirerack.com/installer/installer.jsp', where: 'Online + installers' },
];

const trackClick = (shop: string, placement: string) => {
  try {
    window.gtag?.('event', 'tire_shop_click', { shop, placement, page: window.location.pathname });
  } catch {
    /* analytics must never block the link */
  }
};

export const TireShops = ({ placement, dark = false }: { placement: string; dark?: boolean }) => (
  <div>
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div>
        <h2 className="text-3xl md:text-[2.6rem] leading-[1.1] font-semibold tracking-tight" style={{ fontVariationSettings: '"wdth" 110' }}>
          Need new tires?
        </h2>
        <p className={`mt-3 text-lg max-w-xl ${dark ? 'text-white/70' : 'text-muted'}`}>
          Take your Tread AI report to a tire shop near you. Each link opens the shop’s own store finder.
        </p>
      </div>
    </div>
    <ul className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {SHOPS.map((s) => (
        <li key={s.name}>
          <a
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClick(s.name, placement)}
            className={`group flex h-full items-start gap-4 rounded-2xl p-5 transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-0.5 ${
              dark
                ? 'bg-white/[0.05] ring-1 ring-white/10 hover:ring-white/25'
                : 'bg-white border border-line/70 hover:border-brand-300 hover:shadow-[0_12px_30px_-16px_rgba(20,47,114,0.35)]'
            }`}
          >
            <span
              className={`h-11 w-11 shrink-0 rounded-xl inline-flex items-center justify-center text-[15px] font-semibold ${dark ? 'bg-white/10 text-white' : 'bg-brand-50 text-brand-700'}`}
              aria-hidden="true"
            >
              {s.name.replace(/[^A-Za-z ]/g, '').split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]).join('')}
            </span>
            <span className="flex-1 min-w-0">
              <span className="flex items-center justify-between gap-2">
                <span className="font-semibold">{s.name}</span>
                <svg className={`w-4 h-4 shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 ${dark ? 'text-white/50' : 'text-muted group-hover:text-brand-600'}`} viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M7 17L17 7M9 7h8v8" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              <span className={`mt-1 block text-sm leading-relaxed ${dark ? 'text-white/65' : 'text-muted'}`}>{s.note}</span>
              <span className={`mt-2 inline-block text-xs ${dark ? 'text-white/45' : 'text-muted/80'}`}>{s.where} · Find a store</span>
            </span>
          </a>
        </li>
      ))}
    </ul>
    <p className={`mt-5 text-xs ${dark ? 'text-white/45' : 'text-muted'}`}>Tread AI isn’t affiliated with these retailers and isn’t paid for these links.</p>
  </div>
);
